import { call, put } from 'redux-saga/effects';
import { requestGetVapidPublicKey, requestSubscribePush, requestUnsubscribePush, requestGetPushStatus } from '../requests/push';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetVapidPublicKey(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetVapidPublicKey);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        if (action.payload?.callback) action.payload.callback({ ok: false, message: safeErrorMessage(error) });
    }
}

export function* handleSubscribePush(action) {
    try {
        const { subscriptionData, callback } = action.payload;
        const response = yield call(requestSubscribePush, subscriptionData);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: 'error', message }));
        if (action.payload?.callback) action.payload.callback({ ok: false, message });
    }
}

export function* handleUnsubscribePush(action) {
    try {
        const { endpoint, callback } = action.payload;
        const response = yield call(requestUnsubscribePush, endpoint);
        if (callback) callback({ ok: true, data: response.data });
    } catch (error) {
        if (action.payload?.callback) action.payload.callback({ ok: false, message: safeErrorMessage(error) });
    }
}

export function* handleGetPushStatus(action) {
    const { callback } = action.payload || {};
    try {
        const response = yield call(requestGetPushStatus);
        if (callback) callback(response.data);
    } catch (error) {
        if (callback) callback({ ok: false, status: error?.response?.status || null });
    }
}
